import styled from '@emotion/styled';
import { useIsMobile, useIsTablet } from '@hooks/responsive/useIsMobile';
import Image from 'next/image';
import Link from 'next/link';

// components
import Button from '@components/_atoms/Button';
import Typography from '@components/_atoms/Typography';

// constants
import { ButtonColor, TypoVariant } from '@constants/atoms';
import { MOBILE_MODE, TABLET_MODE } from '@constants/size';
import { white } from '@styles/Colors';
import { useTranslation } from 'next-i18next';
import ButtonCode from '@constants/log/buttonCode';

type Props = {
  fileUrl: string;
};

const Layout = styled.div`
  width: 100%;
  height: 562px;
  background-color: #8dd7fa;
  background-image: linear-gradient(105deg, #8dd7fa 0%, #2d7ddc 100%);

  display: flex;
  justify-content: center;
  align-items: center;

  @media ${TABLET_MODE} {
    height: 450px;
  }
  @media ${MOBILE_MODE} {
    height: 350px;
  }
`;

const Content = styled.div`
  width: 100%;
  max-width: 1120px;

  display: flex;
  align-items: center;
  column-gap: 72px;
  overflow: hidden;

  padding: 0 40px;

  @media ${MOBILE_MODE} {
    padding: 0 20px;
  }
`;

const TextContent = styled.div`
  @media ${MOBILE_MODE} {
    flex-shrink: 0.5;
  }
`;

const DescriptionBox = styled.div`
  display: grid;
  row-gap: 8px;
`;

const ButtonWrapper = styled.div`
  margin-top: 24px;

  display: flex;
`;

const ImageWrapper = styled.div``;

export default function Section3({ fileUrl }: Props) {
  const { t, i18n } = useTranslation('intro');
  const ko = i18n.language === 'ko';

  const isMobile = useIsMobile();
  const isTablet = useIsTablet();

  return (
    <Layout>
      <Content>
        <TextContent>
          <DescriptionBox>
            {ko ? (
              <Typography variant={isMobile ? TypoVariant.B3 : TypoVariant.B1} color={white}>
                {t('section3.text1')}
              </Typography>
            ) : (
              <Typography variant={isMobile ? TypoVariant.B3 : TypoVariant.B3} color={white}>
                {t('section3.text1')}
              </Typography>
            )}

            {ko ? (
              <Typography
                variant={isMobile ? TypoVariant.SH2 : isTablet ? TypoVariant.H6 : TypoVariant.H5}
                color={white}>
                마켓오브메테리얼이
                <br />
                제공하는 서비스가 궁금하신가요?
              </Typography>
            ) : (
              <Typography variant={isMobile ? TypoVariant.SH2 : TypoVariant.SH2} color={white}>
                Know more about the services offered by Market of Material
              </Typography>
            )}
          </DescriptionBox>
          <ButtonWrapper>
            <a href={fileUrl} download>
              <Button
                text={t('section3.download')}
                color={ButtonColor.OutlinedWhite}
                steelbosoId={ButtonCode.BTN_COMPANY_BOTTOM_FILE_DOWNLOAD}
              />
            </a>
          </ButtonWrapper>
        </TextContent>
        <ImageWrapper>
          <Image src={`/assets/images/intro-build.webp`} width={450} height={450} layout="fixed" alt={`intro-build`} />
        </ImageWrapper>
      </Content>
    </Layout>
  );
}
